const readRuntimeConfig = () => {
  if (typeof window === 'undefined') return {};
  return window.__AOZ_CONFIG__ || {};
};

const normalizeConfigValue = (value) => {
  const normalized = String(value || '').trim();
  return normalized || undefined;
};

const runtimeConfig = readRuntimeConfig();
const defaultApiUrl = normalizeConfigValue(process.env.REACT_APP_API_URL) || 'http://localhost:8080';

export const API_URL = normalizeConfigValue(runtimeConfig.API_URL) || defaultApiUrl;
export const SOCKET_URL = (
  normalizeConfigValue(runtimeConfig.SOCKET_URL)
  || normalizeConfigValue(process.env.REACT_APP_SOCKET_URL)
  || API_URL
);
export const RELEASE_SHA = normalizeConfigValue(runtimeConfig.RELEASE_SHA) || 'local';
export const BUILD_TIME = normalizeConfigValue(runtimeConfig.BUILD_TIME) || 'local';

export const getRuntimeConfig = () => ({
  API_URL,
  SOCKET_URL,
  RELEASE_SHA,
  BUILD_TIME,
});
